import { Description } from '@dgx-pr-spa/shared/util';
import { getPricegross, planType } from '@shared/helpers/function.helpers';
import { Offers } from '@dgx-pr-spa/shared/util';
import { DataLayer } from '@dgx-pr-spa/shared/util';
import { OfferType, ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { UpfrontPaymentSummary } from '@dgx-pr-spa/shared/util';
import { CardPaymentRedirectResponse } from '@dgx-pr-spa/shared/util';
import { OfferTaken } from '@dgx-pr-spa/shared/util';
import { ItemOffer } from '@dgx-pr-spa/shared/util';
import { CreateOrderResponse } from '@dgx-pr-spa/shared/util';

export class GAConfirmationPageLoad {
  constructor(
    private readonly upfront: UpfrontPaymentSummary,
    private readonly offers: Offers,
    private readonly selected: ReplacementOffer,
    private readonly payment: CardPaymentRedirectResponse,
    private readonly itemOffer: ItemOffer,
    private readonly order: CreateOrderResponse,
    private readonly form
  ) {}

  get gaData(): DataLayer {
    const offers = this.offers;
    const currentItem = offers?.current_item;
    const customerType = 'G';
    const currentPlan = offers?.current_plan;
    const PRGroup = 'aws';

    const selected = this.selected;
    const upfront = this.upfront;
    const payment = this.payment;

    const productName =
      currentItem?.make && currentItem?.appliance_category
        ? `${currentItem?.make} ${currentItem?.appliance_category}`
        : undefined;

    const upgradeTaken =
      selected?.offer_type === OfferType.UPGRADE ? 'Yes' : 'No';

    const itemOffer = this.itemOffer;
    const order = this.order;

    const installation = selected?.services
      ? getPricegross(selected.services, Description.Installation)
      : undefined;

    const disposal = selected?.services
      ? getPricegross(selected.services, Description.Disposal)
      : undefined;

    const delivery = selected?.services
      ? getPricegross(selected.services, Description.Delivery)
      : undefined;

    const dataLayer: DataLayer = {
      event: 'PRAWS',
      eventPR: 'product-replacement-confirmation',
      pagename: 'product-replacement-confirmation',
      genericpagename: 'product-replacement-checkout',
      category: 'product-replacement',
      OfferType: upfront?.offerType,
      planNumber: currentPlan?.plan_number,
      productName,
      deliveryDate: this.form?.delivery?.expectedDate,
      productModel: currentItem?.model,
      AccountBrand: currentItem?.make,
      Manufacturer: currentItem?.make,
      PlanType: planType(currentPlan),
      productNameOffer: `${selected?.make} ${selected?.appliance_category}`,
      productModelOffer: selected?.model,
      AccountBrandOffer: selected?.make,
      ManufacturerOffer: selected?.make,
      upgrade: selected?.upgrade_fee,
      outstandingMonthlyPayments: upfront?.outstandingMonthlyPayments,
      remainingPayment: upfront?.outstandingPlanAmount,
      installation,
      disposal,
      delivery,
      totalCostReplacement: upfront?.replacementCost,
      PRContinuedCover: upfront?.monthlyPayment,
      PRContinuedCoverDuration: itemOffer?.periodOfCover,
      JobReferenceNumber: upfront?.jobReferenceNumber,
      WorldPayReferenceNumber: payment?.orderNumber,
      PRplanNumber: order?.plan_number,
      customerType,
      paymentOffer: 'MPM',
      upgradeTaken,
      installationTaken: upfront?.isInstallationAvailable
        ? upfront?.isInstallationSelected
          ? 'Yes'
          : 'No'
        : undefined,
      disposalTaken: upfront?.isDisposalAvailable
        ? upfront?.isDisposalSelected
          ? 'Yes'
          : 'No'
        : undefined,
      PRBooking: '1',
      PRContinuedCoverTaken: upfront?.isProtectionSelected ? 'Yes' : 'No',
      rrp: selected?.rrp,
      PRGroup,
    };

    return dataLayer;
  }
}
export class GATakenPageLoad {
  constructor(private readonly taken: OfferTaken) {}

  get gaData(): DataLayer {
    const taken = this.taken;
    const planNumber = taken?.planNumber;

    const dataLayer: DataLayer = {
      event: 'PRAWS',
      eventPR: 'product-replacement-redeemed',
      pagename: 'product-replacement-redeemed',
      genericpagename: 'product-replacement-checkout',
      category: 'product-replacement',
      planNumber,
    };

    return dataLayer;
  }
}
